import { Ploc } from '@hfc/ui-core';
import { StaffMember } from '@/shared/domain/StaffMember';
import { StaffMemberMemory } from '@/shared/infrastructure/dataSource/StaffMemberMemory';
import { GetStaffMembersUseCase } from '@/shared/application/GetStaffMembersUseCase';

const repository = new StaffMemberMemory();
const getStaffMembers = new GetStaffMembersUseCase(repository);

export interface StaffMemberStoreInterface {
  staffMembers: Array<StaffMember>
  staffMembersLoaded: boolean
}

const initialState: StaffMemberStoreInterface = {
  staffMembers: [],
  staffMembersLoaded: false
};

export class StaffMemberStore extends Ploc<StaffMemberStoreInterface> {

  public constructor () {
    super(initialState);
  }

  public async getStaffMembers (): Promise<void> {
    this.changeState({ ...this.state, staffMembersLoaded: false });
    const staffMembers = await getStaffMembers.run();
    this.changeState({ ...this.state, staffMembers: staffMembers, staffMembersLoaded: true });
  }

}
